/**
 * In-job Report tab — the Cost Report scoped to this project automatically.
 * Luke picks dates + options and downloads the branded PDF.
 */
import { useOutletContext } from "react-router-dom";
import CostReportInner from "@/pages/CostReportInner";

export default function ProjectReport() {
  const { project } = useOutletContext();
  return (
    <div data-testid="project-report">
      <CostReportInner forcedProjectId={project.id}/>
    </div>
  );
}
